import { object, string } from 'yup';

export const AddGroupSchema = object({
	name: string().required(),
	code : string().required()
});
